import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { Survey } from '../models/survey';
import { SurveyLink } from '../models/survey-link';

@Injectable()
export class SurveyLinkService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  private survey: Survey; // fixme needed?

  // fetch survey links from the server, apply ordering
  getSurveyLinks(survey: Survey, ordering: string): Observable<SurveyLink[]> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/links/`; // fixme api version
    if (ordering != null) get_url = get_url + `?ordering=${ordering}`;

    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .get(get_url, { headers: headers })
      .map((response: any) => {
        const json = response;
        return json;
      })
      .catch(this.handleError);
  }

  toggleLinkActive(survey: Survey, survey_link: SurveyLink): Observable<any> {
    const url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/links/${survey_link.id}/toggle_active/`;
    console.log('URL: ' + url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .put(url, {}, { headers: headers })
      .map((response: HttpResponse<any>) => {
        const link_json = response;
        survey_link = SurveyLink.fromJSON(link_json);
        survey_link.setSurvey(survey);
        return survey_link;
      })
      .catch(this.handleError);
  }

  addSurveyLink(survey: Survey, survey_link: SurveyLink): Observable<any> {
    this.survey = survey;
    const post_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/links/`;
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, survey_link.toJSON(), { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updateSurveyLink(survey: Survey, survey_link: SurveyLink): Observable<any> {
    this.survey = survey;
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/links/${survey_link.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    console.log('page: ', survey_link.toJSON());
    return (
      this.http
        .put(put_url, survey_link.toJSON(), { headers: headers })
        //     .map(this.processPostPutResponse)
        .catch(this.handleError)
    );
  }

  deleteSurveyLink(survey: Survey, survey_link: SurveyLink): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/links/${survey_link.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .map(this.processDeleteResponse)
      .catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): SurveyLink {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const survey_link: SurveyLink = Object.create(SurveyLink.prototype);
    const obj = Object.assign(survey_link, body, {});
    console.log('this.survey: ', this.survey);
    survey_link.setSurvey(this.survey);
    return obj || {};
  }

  private processDeleteResponse(res: Response) {
    console.log('processDeleteResponse: res: ', res);
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
